import React, { useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../styles/Home.css";

// Data
import testimonials from "../data/testimoniasData";

// Assets
import heroBg from "../assets/herosection.jpg";
import comprehensive from "../assets/services logos/comprehensive.jpg";
import Medical from '../assets/services logos/medical.jpg';
import Psychiatric from '../assets/services logos/psychiatric.jpg';
import SpecialSchool from '../assets/services logos/specialschool.jpg';
import Vocational from '../assets/services logos/vocational.jpg';

// Components
import Footer from "../components/Footer";

// Banner stats icons
import {
  FaUserFriends,
  FaProcedures,
  FaUserMd,
  FaAward,
  FaHospital
} from 'react-icons/fa';

// Specializes treatments recovery Icons
import {
  FaBrain, FaBone, FaUserAlt, FaChild, FaRibbon, FaHeartbeat, FaShieldAlt, FaAssistiveListeningSystems
} from 'react-icons/fa';



// Specialised treatments data

const treatments = [
  {
    icon: <FaBrain />,
    title: 'Neuro Rehabilitation',
    description: 'Specialized programs for recovery from neurological conditions like stroke, brain injury, and spinal cord injury.'
  },
  {
    icon: <FaBone />,
    title: 'Ortho Rehabilitation',
    description: 'Comprehensive care for post-surgery recovery, fractures, and musculoskeletal injuries to restore mobility.'
  },
  {
    icon: <FaUserAlt />,
    title: 'Geriatric Care',
    description: 'Tailored therapy to improve balance, strength, and independence for elderly patients.'
  },
  {
    icon: <FaChild />,
    title: 'Pediatric Therapy',
    description: 'Gentle and effective rehabilitation services for children with developmental or physical challenges.'
  },
  {
    icon: <FaRibbon />,
    title: 'Oncology Rehabilitation',
    description: 'Supportive care to manage the side effects of cancer treatment and improve quality of life.'
  },
  {
    icon: <FaHeartbeat />,
    title: 'Cardio-Pulmonary Rehab',
    description: 'Programs to help patients recover from heart conditions and improve respiratory function.'
  },
  {
    icon: <FaShieldAlt />,
    title: 'De-Addiction Support',
    description: 'A holistic approach to overcome addiction, combining physical and psychological therapies.'
  },
  {
    icon: <FaAssistiveListeningSystems />,
    title: 'Vestibular Rehabilitation',
    description: 'Treatment for dizziness, vertigo, and balance disorders to restore stability and confidence.'
  }
];



// Service Data
const servicesData = [
  {
    id: 1,
    title: "Comprehensive Therapeutic Services",
    description: "Integrated therapy programs customized for physical, mental, and emotional recovery.",
    image: comprehensive,
    path: "/services/Comprehensive-Therapetic-Services",
  },
  {
    id: 2,
    title: "Medical Rehabilitation In-Patient Services",
    description: "24/7 monitored care with expert doctors and evidence-based recovery plans.",
    image: Medical,
    path: "/services/medical-rehabilitation",
  },
  {
    id: 3,
    title: "Psychiatric Rehabilitation In-Patient Services",
    description: "Structured inpatient support for individuals with chronic psychiatric conditions.",
    image: Psychiatric,
    path: "/services/Psychiatric-Rehabilation",
  },
  {
    id: 4,
    title: "Special School for Neuro Developmental Disorders",
    description: "Inclusive education for children with autism, ADHD, and related conditions.",
    image: SpecialSchool,
    path: "/services/Special-School",
  },
  {
    id: 5,
    title: "Vocational Rehabilitation & Adult Living Support",
    description: "Skill-building and adaptive living programs for independent adult life.",
    image: Vocational,
    path: "/services/Ocational-Rehabilation",
  },
];

// Banner stats data
const metrics = [
  {
    icon: <FaUserFriends />,
    number: '5,000+',
    label: 'Patients Treated',
    tag: 'Trusted'
  },
  {
    icon: <FaProcedures />,
    number: '200+',
    label: 'Inpatient Beds',
    tag: 'Capacity'
  },
  {
    icon: <FaHeartbeat />,
    number: '98+',
    label: 'Recovery Rate (%)',
    tag: 'Success'
  },
  {
    icon: <FaUserMd />,
    number: '50+',
    label: 'Specialized Therapists',
    tag: 'Expertise'
  },
  {
    icon: <FaAward />,
    number: '15+',
    label: 'Years of Experience',
    tag: 'Legacy'
  },
  {
    icon: <FaHospital />,
    number: '3+',
    label: 'State-of-the-Art Centers',
    tag: 'Facilities'
  }
];

// Animated count-up for each stat
function useStatsCountUp(stats) {
  const refs = useRef(stats.map(() => React.createRef()));
  useEffect(() => {
    stats.forEach((item, idx) => {
      let start = 0, frame, startTime;
      const end = item.number, duration = item.duration, decimals = item.decimals || 0;
      const ref = refs.current[idx].current;
      if (!ref) return;
      const run = timestamp => {
        if (!startTime) startTime = timestamp;
        const progress = Math.min((timestamp - startTime) / duration, 1);
        let current = start + (end - start) * progress;
        ref.innerText = decimals ? current.toFixed(decimals) : Math.floor(current);
        if (progress < 1) frame = requestAnimationFrame(run);
        else ref.innerText = decimals ? end.toFixed(decimals) : end;
      };
      frame = requestAnimationFrame(run);
      return () => cancelAnimationFrame(frame);
    });
  }, [stats]);
  return refs.current;
}

const Home = () => {
  const navigate = useNavigate();
  const homeTestimonials = testimonials.slice(0, 3);



  return (
    <div>

      {/* Hero Section */}
      <section
        className="hero-attractive"
        style={{
          backgroundImage: `url(${heroBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="hero-overlay"></div>
        <div className="hero-attractive-content">
          <p className="hero-tagline">India's Most Trusted Rehab Network</p>
          <h1 className="hero-attractive-title">
            Empowering <span>Your</span> Recovery Journey
          </h1>
          <p className="hero-attractive-subtext">
            Evidence-based, compassionate care for neurological, psychiatric, and developmental challenges — trusted by 50,000+ families across India.
          </p>
          <div className="hero-attractive-buttons">
            <Link to="/services" className="hero-btn-primary">
              <i className="fa-solid fa-heart-pulse"></i> Start Your Recovery
            </Link>

            <Link to="/testimonials" className="hero-btn-secondary">
              <i className="fa-solid fa-circle-play"></i> Watch Our Impact
            </Link>
          </div>
          <div className="hero-metrics-highlight">
            <div>
              <strong>28+</strong>
              <span>Years of Excellence</span>
            </div>
            <div>
              <strong>50K+</strong>
              <span>Lives Transformed</span>
            </div>
            <div>
              <strong>95%</strong>
              <span>Success Rate</span>
            </div>
            <div>
              <strong>24/7</strong>
              <span>Emergency Care</span>
            </div>
          </div>
        </div>
      </section>

      {/* Specialized Recovery Treatments */}
      <section className="recovery-section">
        <div className="container">
          <h2 className="section-title">Specialized Recovery Treatments</h2>
          <p className="section-subtitle">
            We offer a wide range of specialized therapies to cater to the unique needs of each patient on their path to recovery.
          </p>

          <div className="card-grid">
            {treatments.map((treatment, index) => (
              <div className="card" key={index}>
                <div className="icon-wrapper">{treatment.icon}</div>
                <h3>{treatment.title}</h3>
                <p>{treatment.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Banner Section: Trusted by Thousands */}
      <section className="trust-section">
        <div className="container">
          <h2 className="trust-title">Trusted by Thousands</h2>
          <p className="trust-subtitle">
            Our commitment to excellence is reflected in our numbers and the lives we've changed.
          </p>

          <div className="metrics-grid">
            {metrics.map((item, index) => (
              <div className="metric-card">
                <div className="metric-header">
                  <div className="metric-icon">{item.icon}</div>
                  <div className="metric-tag">{item.tag}</div>
                </div>
                <div className="metric-content">
                  <div className="metric-number">{item.number}</div>
                  <div className="metric-label">{item.label}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>


      {/* Services Preview Section */}
      <section className="home-services-section">
        <h1 className="home-services-heading">Our Specialized Services</h1>
        <p className="home-services-subtitle">
          Empowering recovery through expert-led, personalized care that transforms lives.
        </p>

        <div className="home-services-container">
          {servicesData.map((service) => (
            <div key={service.id} className="home-service-card">
              <img
                src={service.image}
                alt={service.title}
                className="home-service-image"
              />
              <div className="home-service-content">
                <h2 className="home-service-title">{service.title}</h2>
                {service.description && (
                  <p className="home-service-description">{service.description}</p>
                )}
                <Link to={service.path} className="know-more-btn">
                  Know More <i className="fa-solid fa-arrow-right-long"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div className="home-services-footer">
          <button className="view-all-btn" onClick={() => navigate("/services")}>
            View All Services
          </button>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="home-testimonials">
        <h2 className="home-testimonials__title">Hear from the Healed</h2>
        <p className="home-testimonials__subtitle">
          Happy patients share their kind words and experiences.
        </p>

        <div className="home-testimonials__grid">
          {homeTestimonials.map((testimonials) => (
            <article key={testimonials.id} className="home-testimonials__card">
              <header className="home-testimonials__card-header">
                <div className="home-testimonials__user">
                  <img src={testimonials.image} alt={testimonials.name} className="home-testimonials__avatar" />
                  <div className="home-testimonials__user-meta">
                    <span className="home-testimonials__name">{testimonials.name}</span>
                    <span className="home-testimonials__role">{testimonials.role}</span>
                  </div>
                </div>
                <div className="home-testimonials__rating" aria-label={`${testimonials.rating} out of 5`}>
                  {"★".repeat(testimonials.rating)}
                  {"☆".repeat(5 - testimonials.rating)}
                </div>
              </header>

              <div className="home-testimonials__treatment">{testimonials.treatment}</div>

              <p className="home-testimonials__text">
                {testimonials.feedback}
              </p>
            </article>
          ))}
        </div>

        <button
          className="home-testimonials__cta"
          onClick={() => navigate("/testimonials")}
          type="button"
        >
          View More
        </button>
      </section>


      <Footer />
    </div>
  );
};

export default Home;
